<template>
  <div class="gbsel">
    <div class="gbsel__col">
      <label class="gbsel__label" for="gbsel-day">Tag</label>
      <v-select
        id="gbsel-day"
        v-model="selDay"
        :items="days"
        :menu-props="{ maxHeight: 320 }"
        class="gbsel__field"
      ></v-select>
    </div>
    <div class="gbsel__col">
      <label class="gbsel__label" for="gbsel-month">Monat</label>
      <v-select
        id="gbsel-month"
        v-model="selMonth"
        :items="months"
        item-value="id"
        item-title="name"
        :menu-props="{ maxHeight: 320 }"
        class="gbsel__field"
      ></v-select>
    </div>
    <div class="gbsel__col">
      <label class="gbsel__label" for="gbsel-year">Jahr</label>
      <v-select
        id="gbsel-year"
        v-model="selYear"
        :items="years"
        :menu-props="{ maxHeight: 320 }"
        class="gbsel__field"
      ></v-select>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed, defineProps, defineEmits } from "vue";

const props = defineProps({
  day: {
    type: Number,
    default: new Date().getDate(),
  },
  month: {
    type: Number,
    default: new Date().getMonth() + 1,
  },
  year: {
    type: Number,
    default: new Date().getFullYear(),
  },
});

const emit = defineEmits(["update:day", "update:month", "update:year"]);

const selDay = ref(props.day);
const selMonth = ref(props.month);
const selYear = ref(props.year);

const days = computed(() => {
  const daysInMonth = new Date(selYear.value, selMonth.value, 0).getDate();
  return Array.from({ length: daysInMonth }, (_, i) => i + 1);
});

const months = [
  { id: 1, name: "Januar" },
  { id: 2, name: "Februar" },
  { id: 3, name: "März" },
  { id: 4, name: "April" },
  { id: 5, name: "Mai" },
  { id: 6, name: "Juni" },
  { id: 7, name: "Juli" },
  { id: 8, name: "August" },
  { id: 9, name: "September" },
  { id: 10, name: "Oktober" },
  { id: 11, name: "November" },
  { id: 12, name: "Dezember" },
];

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 100 }, (_, i) => currentYear - i);

watch(selDay, (newValue) => {
  emit("update:day", newValue);
});

watch(selMonth, (newValue) => {
  emit("update:month", newValue);
});

watch(selYear, (newValue) => {
  emit("update:year", newValue);
});
</script>

<style scoped>
.gbsel {
  display: grid;
  grid-template-columns: minmax(64px, 0.8fr) minmax(108px, 1.4fr) minmax(80px, 1fr);
  gap: 6px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  align-items: end;
}
.gbsel__col {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.gbsel__field :deep(.v-field) {
  min-width: 0 !important;
  width: 100%;
}
.gbsel__field :deep(.v-field__field) {
  min-width: 0 !important;
}
.gbsel__label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #5b6473;
  line-height: 1.2;
}
.gbsel__field {
  width: 100%;
}

.gbsel__field :deep(.v-field) {
  border-radius: 3px !important;
}
.gbsel__field :deep(.v-field__outline) {
  --v-field-border-opacity: 0.6;
}
.gbsel__field :deep(.v-label) {
  display: none !important;
}
.gbsel__field :deep(.v-field__input) {
  color: #0f172a !important;
  font-size: 15px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  padding-inline-start: 10px;
  padding-inline-end: 4px;
  min-height: 44px;
  min-width: 0;
  line-height: 1.2;
}
.gbsel__field :deep(.v-select__selection) {
  color: #0f172a !important;
  margin-top: 0;
}
.gbsel__field :deep(.v-select__selection-text) {
  color: #0f172a !important;
  opacity: 1 !important;
  font-weight: 600;
}
.gbsel__field :deep(.v-field__append-inner) {
  padding-inline-start: 2px;
}
.gbsel__field :deep(.v-field__append-inner .v-icon) {
  color: #0f4c81 !important;
  font-size: 20px;
  opacity: 1;
}

@media (max-width: 600px) {
  .gbsel {
    grid-template-columns: minmax(56px, 0.8fr) minmax(96px, 1.4fr) minmax(74px, 1fr);
    gap: 5px;
  }
  .gbsel__field :deep(.v-field__input) {
    font-size: 14px;
    min-height: 42px;
    padding-top: 9px !important;
    padding-bottom: 9px !important;
    padding-inline-start: 8px;
    padding-inline-end: 2px;
  }
  .gbsel__field :deep(.v-field__append-inner) {
    padding-inline-start: 0;
  }
}
</style>
